import React, { useState } from 'react';

import CreateDashboardPage from './create/CreateDashboardPage';

const initialDashboardState = {
  templates: [],
  name: '',
};

const DashboardEditMode = ({
  onBack,
  isCreate,
  dashboardName,
  setDashboardName,
  saveDashboard,
  updateDashboard,
  dashboardsObj,
  dashboardId,
  units,
}) => {
  const [dashboard, setDashboard] = useState(
    isCreate ? initialDashboardState : dashboardsObj[dashboardId]
  );

  return (
    <CreateDashboardPage
      onBack={onBack}
      dashboard={dashboard}
      setDashboard={setDashboard}
      dashboardName={dashboardName}
      setDashboardName={setDashboardName}
      existedDashboardNames={[...Object.values(dashboardsObj).map((o) => o.name)]}
      isCreate={isCreate}
      units={units}
      saveDashboard={isCreate ? saveDashboard : updateDashboard}
    />
  );
};

export default DashboardEditMode;
